<template lang="pug">

div.nopadding
    div.fullwidth(v-if="$route.params.lang == 'en'")
        .content-container
            hgroup
                h2 BSS Hochspannungstechnik is now ISO 9001:2015 certified
                p.subtitle Sindelfingen, 2025
            .columns
                picture.bigbox-image(style="flex: 0 0 40%; max-width: 40%;")
                    img( src='@/assets/logos/SGS_ISO_9001.jpg', width="40%", alt='SGS ISO 9001', title='SGS ISO 9001')

                div.bigbox-text(style="flex: 0 0 60%; max-width: 60%;")
                    p BSS Hochspannungstechnik GmbH has successfully achieved  
                        b ISO 9001:2015 
                        | certification.
                    
                    p This confirms that our internal processes, development workflows, and production structures meet internationally recognized quality standards.
                    p The audit was completed without any deviations, reinforcing our commitment to providing precise and robust solutions for condition assessment of power transformers and other assets in the electrical grid.
                    Downloadlink(
                        text='-> View certificate: ISO 9001:2015 Certificate (pdf, english)',
                        link="/pdf/Certificate_ISO_9001.pdf",
                        :showIcon="false",
                    )

        .content-container
            hgroup
                h2 Our BSFZ certification is here!
                p.subtitle Sindelfingen, 2025
            .columns
                div.bigbox-text(style="flex: 0 0 60%; max-width: 60%;")
                    p We have made it! For the second time in a row, BSS Hochspannungstechnik GmbH has been approved for the federal research grant and can proudly display the BSFZ logo for another term. But what does this mean for us?
                    p First of all: BSFZ stands for „Bescheinigungsstelle Forschungszulage“. This is a German tongue twister and means in English: “Federal Support for Research and Development”.
                    p This program to promote innovation from the German government enables us to put our creative ideas into practice, be it in the form of new technologies or quirky projects that we might otherwise have hidden away in a drawer.
                    p What does that mean in concrete terms? For our team, it means not only more resources, but also the opportunity to work more boldly and daringly on our partial discharge monitoring systems for power transformers. With this funding, we can implement our ideas faster and further increase the reliability and efficiency of our systems.

                picture.bigbox-image(style="flex: 0 0 40%; max-width: 40%;")
                    img(src='@/assets/logos/BSFZ_Siegel_2025.png', width="60%", alt='BSFZ Siegel 2025', title='BSFZ Siegel 2025')

        .content-container
            hgroup
                h2 Two Strong Brands, one Shared Vision
                p.subtitle Sindelfingen, Germany – May 28, 2025
            .columns
                picture.bigbox-image
                    img( src='@/assets/extras/20250528_Goetz_Siegel_1000.jpg', width="100%", alt='left: R. Götz (MR), right: M. Siegel (BSS)', title='left: R. Götz (MR), right: M. Siegel (BSS)')
                div.bigbox-text
                    p 
                        | We’re excited to announce that 
                        b Maschinenfabrik Reinhausen GmbH
                        |  (MR) has acquired a minority stake in 
                        b BSS Hochspannungstechnik GmbH
                        |  (BSS).
                    p MR, headquartered in Regensburg, Germany, brings with almost 5,000 employees worldwide the claim “THE POWER BEHIND POWER” to life. MR is a global leader in transformer monitoring and control, while we at BSS specialize in high-end partial discharge (PD) monitoring solutions for power transformers and other critical electrical assets. 
                    p
                        | Now, we are joining forces: combining decades of experience to offer even more powerful solutions for transformer lifecycle management, e.g. by integrating our multi-sensor PD monitoring system 
                        b PDM-600
                        |  and our 
                        b UHF PD sensors
                        |  into 
                        b ETOS®
                        |  (Embedded Transformer Operating System).
                    | What remains unchanged:
                    ul
                        li BSS stays an independent company
                        li Same team, same management, same commitment
                    p
                        | For our customers and partners, this means: the same reliable contacts, the same product quality, and an even stronger focus on what we do best: 
                        b Advanced PD monitoring made in Germany
                        | . Now with a strong new partner on our side.
                    p This partnership enhances our global reach, accelerates innovation, and opens new opportunities for utilities, OEMs, and industrial operators worldwide.

        .content-container
            hgroup
                h2 Measurement technology that makes grids smarter
                p.subtitle Leonberg, 2019
            .columns
                div.bigbox-text
                    p
                        | Together with the 
                        b University of Stuttgart 
                        |and 
                        b Pfisterer Kontaktsysteme GmbH 
                        |as well as 
                        b Netze BW GmbH 
                        | as an associated partner, 
                        b BSS Hochspannungstechnik GmbH 
                        | is starting a three-year research and development project. 
                        p The aim of the project is to determine the condition of assets such as cable joints and transformers by suitable measurement technology and to predict their overload capacity. The project is supported by the German Federal Ministry for Economic Affairs and Energy. 
                        p BSS will develop a measurement system and a data platform for temperature and partial discharge measurement data of cable joints and transformers.  
                picture.bigbox-image
                    img( src='@/assets/photos/news/Zubrene.png', width="100%", alt='Projektstart ZübReNe', title='Projektstart ZübReNe')

    div.fullwidth(v-if="$route.params.lang == 'de'")

        .content-container
            hgroup
                h2 BSS Hochspannungstechnik ist nun ISO 9001:2015 zertifiziert
                p.subtitle Sindelfingen, 2025
            .columns
                picture.bigbox-image(style="flex: 0 0 40%; max-width: 40%;")
                    img( src='@/assets/logos/SGS_ISO_9001.jpg', width="40%", alt='SGS ISO 9001', title='SGS ISO 9001')

                div.bigbox-text(style="flex: 0 0 60%; max-width: 60%;")
                    p Die BSS Hochspannungstechnik GmbH hat erfolgreich die 
                        b ISO 9001:2015 
                        | Zertifizierung erhalten.
                    
                    p Damit wird bestätigt, dass unsere internen Prozesse, unsere Entwicklungsabläufe und unsere Produktionsstrukturen den international anerkannten Qualitätsstandards entsprechen.
                    p Das Audit wurde ohne Abweichungen abgeschlossen und unterstreicht unseren Anspruch, unseren Kunden dauerhaft präzise und robuste Lösungen für die Zustandsüberwachung von Leistungstransformatoren und anderen Betriebsmitteln im Stromnetz bereitzustellen.
                    Downloadlink(
                        text='-> Zertifikat ansehen: ISO 9001:2015 Zertifikat (pdf, english)',
                        link="/pdf/Certificate_ISO_9001.pdf",
                        :showIcon="false",
                    )

        .content-container
            hgroup
                h2 Unsere BSFZ-Zertifizierung ist da!
                p.subtitle Sindelfingen, 2025
            .columns
                div.bigbox-text(style="flex: 0 0 60%; max-width: 60%;")
                    p Wir haben es geschafft! Die BSS Hochspannungstechnik GmbH hat im zweiten Jahr in Folge den Bundeszuschuss für Forschung erhalten und darf weiterhin stolz das BSFZ-Logo tragen. Aber was bedeutet das für uns?
                    p Das Innovationsförderinstrument „Forschungszulage“ der deutschen Bundesregierung ermöglicht es uns, unsere kreativen Ideen in die Praxis umzusetzen, sei es in Form neuer Technologien oder ausgefallener Projekte, die wir sonst vielleicht in der Schublade versteckt hätten.
                    p Was bedeutet das konkret? Für unser Team bedeutet dies nicht nur mehr Ressourcen, sondern auch die Möglichkeit, mutiger und risikofreudiger an unseren Teilentladungsüberwachungssystemen für Leistungstransformatoren zu arbeiten. Mit dieser Förderung können wir unsere Ideen schneller umsetzen und die Zuverlässigkeit und Effizienz unserer Systeme weiter steigern.
                
                picture.bigbox-image(style="flex: 0 0 40%; max-width: 40%;")
                    img( src='@/assets/logos/BSFZ_Siegel_2025.png', width="60%", alt='BSFZ Siegel 2025', title='BSFZ Siegel 2025')

        .content-container
            hgroup
                h2 Zwei starke Marken, eine gemeinsame Vision
                p.subtitle Sindelfingen, Deutschland - 28. Mai 2025
            .columns
                picture.bigbox-image
                    img( src='@/assets/extras/20250528_Goetz_Siegel_1000.jpg', width="100%", alt='links: R. Götz (MR), rechts: M. Siegel (BSS)', title='links: R. Götz (MR), rechts: M. Siegel (BSS)')
                div.bigbox-text
                    p 
                        | Wir freuen uns, bekannt zu geben, dass die 
                        b Maschinenfabrik Reinhausen GmbH
                        |  (MR) eine Minderheitsbeteiligung an der 
                        b BSS Hochspannungstechnik GmbH
                        |  (BSS) erworben hat.
                    p MR, mit Hauptsitz in Regensburg, erweckt mit fast 5.000 Mitarbeitern weltweit den Slogan „THE POWER BEHIND POWER“ zum Leben. MR ist weltweit führend in der Überwachung und Steuerung von Transformatoren, während wir von BSS uns auf High-End-Teilentladungsüberwachungslösungen für Leistungstransformatoren und andere kritische elektrische Betriebsmittel spezialisiert haben.
                    p
                        | Jetzt kombinieren wir unsere jahrzehntelange Erfahrung, um noch leistungsfähigere Lösungen für das Lifecycle-Management von Transformatoren anzubieten, z.B. durch die Integration unseres Multi-Sensor TE-Monitoring-Systems 
                        b PDM-600
                        |  und unserer 
                        b UHF-TE-Sensoren
                        |  in 
                        b ETOS®
                        |  (Embedded Transformer Operating System).
                    | Was unverändert bleibt:
                    ul
                        li BSS bleibt ein unabhängiges Unternehmen
                        li Gleiches Team, gleiches Management, gleiches Commitment
                    p
                        | Für unsere Kunden und Partner bedeutet das: dieselben zuverlässigen Ansprechpartner, dieselbe Produktqualität und eine noch stärkere Konzentration auf das, was wir am besten können: 
                        b Fortschrittliches TE-Monitoring made in Germany
                        | . Jetzt mit einem starken neuen Partner an unserer Seite.
                    p Diese Kooperation erhöht unsere globale Reichweite, beschleunigt Innovationen und eröffnet neue Möglichkeiten für Energieversorger, OEMs und industrielle Betreiber weltweit.

        .content-container
            hgroup
                h2 Messtechnik, die Netze intelligenter macht
                p.subtitle Leonberg, 2019
            .columns
                div.bigbox-text
                    p
                        | Gemeinsam mit der 
                        b Universität Stuttgart 
                        | und der 
                        b Pfisterer Kontaktsysteme GmbH 
                        | sowie der 
                        b Netze BW GmbH 
                        | als assoziiertem Partner startet die 
                        b BSS Hochspannungstechnik GmbH 
                        | ein dreijähriges Forschungs- und Entwicklungsprojekt. 
                        p Ziel des Projekts ist es, den Zustand von Betriebsmitteln wie Kabelverbindungen und Transformatoren durch geeignete Messtechnik zu erfassen und deren Überlastbarkeit vorherzusagen. Das Projekt wird vom Bundesministerium für Wirtschaft und Energie gefördert. 
                        p Die BSS wird ein Messsystem und eine Datenplattform für Temperatur- und Teilentladungsmessdaten von Kabelverbindungen und Transformatoren entwickeln.
                picture.bigbox-image
                    img( src='@/assets/photos/news/Zubrene.png', width="100%", alt='Projektstart ZübReNe', title='Projektstart ZübReNe')

</template>

<script>
export default {
    meta: {
        de: {
            title: "News - BSS Hochspannungstechnik GmbH",
            description: "Produkt- und Projektneuigkeiten von der BSS",
        },
        en: {
            title: "News - BSS Hochspannungstechnik GmbH",
            description: "Product and Project News from BSS",
        },
    },
};
</script>

<style lang="sass" scoped>
.news-container
    display: flex
    flex-direction: column
    align-items: stretch
    // -moz-osx-font-smoothing: grayscale
    // -webkit-font-smoothing: antialiased
    h2.news-title
        padding: 10px
        padding-left: 60px
        font-size: 1.3em
        margin: 0
        // color: black
        font-size: 1.5em
        font-smooth: never
        @media(max-width: $mobile-breakpoint)
            padding-left: 30px
    .news-item
        // background-color: whitesmoke
        padding: 10px
        display: flex
        margin: 20px 40px
        &:first-child
            margin-top: 0
        @media(max-width: $mobile-breakpoint)
            flex-direction: column
            margin: 10px 10px
        .news-image-container
            // flex: 0 0 400px
            .news-image
                width: 400px
                // max-height: 200px
                max-width: 400px
                @media(max-width: $mobile-breakpoint)
                    flex: 0 0 auto
                    width: auto
                    max-width: 100%
                    margin: 0
        .news-textbox
            margin: 0 20px
            @media(max-width: $mobile-breakpoint)
                margin: 0 10px
                margin-top: 5px
            .news-title
                font-weight: 300
                margin-bottom: 2px
                @media(max-width: $mobile-breakpoint)
                    letter-spacing: -0.02em
            .news-text
                // color: black
                font-size: 10pt
    .allnews-link
        margin-left: 50px

.content-container
    margin: 60px 40px

    @media (max-width: $mobile-breakpoint)
        margin: 40px 20px
        margin-bottom: 80px

.content-picture
    img
        max-height: 300px
        object-fit: contain

.columns
    display: flex
    ul
        li
            margin-bottom: 4px
    >div
        display: flex
        flex-direction: column
    @media (max-width: $mobile-breakpoint)
        flex-direction: column

.bigbox-image
    flex: 180px 1 1
    padding-right: 20px
    display: flex
    justify-content: center
    align-items: center
.bigbox-text
    flex: 200px 1 1

.small-box-container
    display: flex
    justify-content: space-between
    flex-wrap: wrap
    align-items: center
        
.small-box
    background-color: whitesmoke
    border-radius: 4px
    position: relative
    padding: 20px
    display: flex
    flex-direction: column
    align-items: center
    flex-basis: 200px
    flex-grow: 1
    padding-bottom: 70px
    margin-bottom: 10px
    margin-right: 20px
    &:last-child
        margin-right: 0
</style>